import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

export function DataComponents(el) {
	for (let e of el.querySelectorAll(`[data-component]`)) {
		let c = e.getAttribute(`data-component`);
		let f = window[c];
		if (!f) {
			console.error(`Failed to find constructor for data-componet = ${c}`);
		}
		// console.log(`window[${c}] = `, f);
		let comp = new f(e);
		console.log('Instantianted ', comp, ' on ', e);
	}
}

export function DataInstance(el) {
	for (let e of el.querySelectorAll(`[data-instance]`)) {
		let c = e.getAttribute(`data-instance`);		
	}
}

